export default "__VITE_ASSET__usszQIfj__"